module.exports = __webpack_public_path__ + "static/media/search-24px-dark.54820d1b.svg";